import sanitize from 'sanitize-html';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSeoRichText } from '../../../selectors/landing';

export const RICH_TEXT_SANITIZE_OPTIONS: sanitize.IOptions = {
  allowedTags: [
    'p',
    'br',
    'a',
    'b',
    'strong',
    'i',
    'em',
    'u',
    's',
    'ul',
    'ol',
    'li',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'div',
    'table',
    'td',
    'caption',
    'col',
    'colgroup',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'li',
    'ul',
    'ol',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
  },
  transformTags: {
    a: (tagName, attribs) => ({
      tagName,
      attribs: {
        ...attribs,
        ...(attribs.target === '_blank' && { rel: 'noreferrer' }),
      },
    }),
  },
};

export const useSanitizedRichText = () => {
  const richText = useSelector(selectSeoRichText);

  return React.useMemo(() => (richText ? sanitize(richText, RICH_TEXT_SANITIZE_OPTIONS) : null), [richText]);
};
